import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Nav from "../../../components/Nav";

const WaiverAgreement = () => {
  const [agree, setAgree] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = location;
  const { cashTokenNew } = state || {};

  const handleContinue = () => {
    if (!agree) return;

    if (cashTokenNew) {
      // If user came with cash token → go to auto-payment
      navigate("/process-cash-payment", { state: { cashTokenNew } });
    } else {
      // Default → membership page
      navigate("/athlete-membership", { state: { fromWaiver: true } });
    }
  };

  return (
    <>
      <Nav />

      <div className="max-w-4xl mx-auto mt-8 bg-white p-6 rounded shadow">
        <h2 className="text-2xl font-bold mb-4">
          Waiver & Liability Agreement
        </h2>

        <div className="text-gray-700 leading-relaxed mb-6 max-h-96 overflow-y-scroll border p-4 rounded">
          {/* Replace this with actual waiver text */}
          <p>
            By participating in this event, the athlete agrees to release Spot
            Combine, coaches, staff, and all event organizers from all liability
            related to injuries, accidents, or damages that may occur before,
            during, or after the event. Athlete and parent/guardian acknowledge
            that participation involves physical activity and risks.
          </p>
          <p className="mt-3">
            By checking the box below, you acknowledge that you have read,
            understood, and agree to the terms of this waiver.
          </p>
        </div>

        <label className="flex items-center gap-3 mt-4">
          <input
            type="checkbox"
            checked={agree}
            onChange={() => setAgree(!agree)}
            className="h-5 w-5"
          />
          <span className="text-lg font-semibold">
            I Agree to the Waiver Terms
          </span>
        </label>

        <button
          disabled={!agree}
          onClick={handleContinue}
          className={`mt-6 w-full py-3 rounded text-white text-lg ${
            agree
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-gray-300 cursor-not-allowed"
          }`}
        >
          Continue
        </button>
      </div>
    </>
  );
};

export default WaiverAgreement;
